import { createReducer } from "@reduxjs/toolkit"
import { fetchCheckInVehicleForWorkshopThunk } from "../thunks/vehicles";
import { Vehicle } from "../../types/vehicle";

const initialVehicleReducer: {
  isLoading: boolean, 
  checkedInVehicle?: Vehicle[]} = {
    isLoading: false
};


export const vehicleReducer = createReducer(initialVehicleReducer, (builder) => {
  builder.addCase(fetchCheckInVehicleForWorkshopThunk.fulfilled, (state, action) => {
    return {
      ...state,
      checkedInVehicle: action.payload, 
      isLoading: false
    };
  })


  builder.addCase("CLEAR_APP_SETTINGS", (state, action) => {
    return initialVehicleReducer
   
  });


  builder.addDefaultCase((state) => {return state})
})
